import { Step } from 'react-joyride';
import React from 'react';

export const stepsMobilePage1: Step[] = [
	{
		// 1
		target: 'body',
		placement: 'center',
		content: (
			<div>
				<h3>Welcome to Pearsana!</h3>
				<p>Your secure digital wallet for academic and professional documents.</p>
				<h4>Let’s start with a quick tour!</h4>
			</div>
		),
		disableBeacon: true
	},
	{
		// 7
		target: '.menu-drawer-btn',
		content: (
			<div>
				<h3>This is where you access your Main Menu</h3>
				<p>Lets take a look inside Menu.</p>
			</div>
		),
		disableBeacon: true
	},
	{
		// 2
		target: '.wallet-menu-item',
		content: (
			<div>
				<h3>Your Private Wallet!</h3>
				<p>
					You can store personal, academic, and many more document types here. You can even create your own
					custom categories.
				</p>
				<h4>Only you can see them — unless you choose to share.</h4>
			</div>
		),
		disableBeacon: true
	},
	{
		// 3
		target: '.firstWalletCategory',
		content: (
			<div>
				<h3>Organise your documents!</h3>
				<p>
					For example, this is your first category tile, where you can securely store transcripts, acceptance
					letters, attested certificates, equivalency documents, EmSAT results, and other records from your
					educational journey.
				</p>
				<h4>Only you can see them—unless you choose to share.</h4>
			</div>
		),
		disableBeacon: true
	},
	{
		// 4
		target: '.uploadDocBtn',
		content: (
			<div>
				<h3>Click here to upload a document!</h3>
				<p>You can also upload documents within each tile.</p>
			</div>
		),
		disableBeacon: true
	},
	{
		// 5
		target: '.verification-menu-item',
		content: (
			<div>
				<h3>Verify your documents!</h3>
				<p>
					This is where you can request and manage the verification of your documents through trusted
					institutions and blockchain-backed approval.
				</p>
				<h4>This is a simple and easy process that allows your documents to stay with you for life!</h4>
			</div>
		),
		disableBeacon: true
	},
	{
		// 9
		target: '.journey-profile-menu-item',
		content: (
			<div>
				<h3>We are excited to support your next steps!.</h3>
				<p>
					Complete your educational or employability profile so the Pearsana platform can connect you with
					educational institutions and employers suited to you and your future!
				</p>
				<h4>More info = better matches. These profiles take 2 minutes to complete.</h4>
			</div>
		),
		disableBeacon: true
	},
	{
		// 11
		target: '.portal-menu-item',
		content: (
			<div>
				<h3>Find Your Next Step</h3>
				<p>The portal is where you can browse and connect with institutions and employers.</p>
				<h4>
					We create ‘Pearsana Matches’ based on your wants/ needs to help guide you in the best direction for
					your future.
				</h4>
			</div>
		),
		disableBeacon: true
	},
	{
		// 12
		target: '.my-enquiries-menu-item',
		content: (
			<div>
				<h3>Track Your Connections</h3>
				<p>
					This is where you can track all the connections you have made within the portal, whether it’s you
					expressing interest in an organization, or visa versa.
				</p>
			</div>
		),
		disableBeacon: true
	},
	{
		// 13
		target: '.shared-wallet-menu-item',
		content: (
			<div>
				<h3>Share Your Documents</h3>
				<p>
					Where institutions or companies can send you document requests, allowing you to pull the needed
					documents directly from your personal wallet.{' '}
				</p>
				<h4>Allowing institutions and employers to be confident in the legitimacy of your documents!</h4>
			</div>
		),
		disableBeacon: true
	},
	{
		// 14
		target: '.profile-icon-btn',
		content: (
			<div>
				<h3>This is your Profile Menu!</h3>
				<p>Lets take a look inside.</p>
			</div>
		),
		disableBeacon: true
	},
	{
		// 15
		target: '.profile-menu-item',
		content: (
			<div>
				<h3>Your Profile Section</h3>
				<p>Change and or update any personal information here. </p>
			</div>
		),
		disableBeacon: true
	},
	{
		// 15
		target: '.my-account-menu-item',
		content: (
			<div>
				<h3>Track Your Usage</h3>
				<p>Utilize the account section to track your usage and previous order history. </p>
				<h4>Browse products and upgrades here also.</h4>
			</div>
		),
		disableBeacon: true,
		placement: 'bottom'
	},
	{
		// 15
		target: '.faq-menu-item',
		content: (
			<div>
				<h3>Frequently Asked Questions</h3>
				<p>Click here if there are any questions you have!</p>
			</div>
		),
		disableBeacon: true,
		placement: 'bottom'
	},
	{
		// 1
		target: 'body',
		placement: 'center',
		content: (
			<div>
				<h3>Thats Everything!</h3>
				<p>You have completed the self guided tour</p>
				<h4>Time to enjoy using the app!</h4>
			</div>
		),
		disableBeacon: true
	}
];

export const stepsDesktopPage1: Step[] = [
	{
		// 1
		target: 'body',
		placement: 'center',
		content: (
			<div>
				<h3>Welcome to Pearsana!</h3>
				<p>Your secure digital wallet for academic and professional documents.</p>
				<h4>Let’s start with a quick tour!</h4>
			</div>
		),
		disableBeacon: true
	},
	{
		// 2
		target: '.wallet-menu-item',
		content: (
			<div>
				<h3>Your Private Wallet!</h3>
				<p>
					You can store personal, academic, and many more document types here. You can even create your own
					custom categories.
				</p>
				<h4>Only you can see them — unless you choose to share.</h4>
			</div>
		),
		disableBeacon: true
	},
	{
		// 3
		target: '.firstWalletCategory',
		content: (
			<div>
				<h3>Organise your documents!</h3>
				<p>
					For example, this is your first category tile, where you can securely store transcripts, acceptance
					letters, attested certificates, equivalency documents, EmSAT results, and other records from your
					educational journey.
				</p>
				<h4>Only you can see them—unless you choose to share.</h4>
			</div>
		),
		disableBeacon: true
	},
	{
		// 4
		target: '.uploadDocBtn',
		content: (
			<div>
				<h3>Click here to upload a document!</h3>
				<p>You can also upload documents within each tile.</p>
			</div>
		),
		disableBeacon: true
	},
	{
		// 5
		target: '.verification-menu-item',
		content: (
			<div>
				<h3>Verify your documents!</h3>
				<p>
					This is where you can request and manage the verification of your documents through trusted
					institutions and blockchain-backed approval.
				</p>
				<h4>This is a simple and easy process that allows your documents to stay with you for life!</h4>
			</div>
		),
		disableBeacon: true
	},
	{
		// 9
		target: '.journey-profile-menu-item',
		content: (
			<div>
				<h3>We are excited to support your next steps!.</h3>
				<p>
					Complete your educational or employability profile so the Pearsana platform can connect you with
					educational institutions and employers suited to you and your future!
				</p>
				<h4>More info = better matches. These profiles take 2 minutes to complete.</h4>
			</div>
		),
		disableBeacon: true
	},
	{
		// 11
		target: '.portal-menu-item',
		content: (
			<div>
				<h3>Find Your Next Step</h3>
				<p>The portal is where you can browse and connect with institutions and employers.</p>
				<h4>
					We create ‘Pearsana Matches’ based on your wants/ needs to help guide you in the best direction for
					your future.
				</h4>
			</div>
		),
		disableBeacon: true
	},
	{
		// 12
		target: '.my-enquiries-menu-item',
		content: (
			<div>
				<h3>Track Your Connections</h3>
				<p>
					This is where you can track all the connections you have made within the portal, whether it’s you
					expressing interest in an organization, or visa versa.
				</p>
			</div>
		),
		disableBeacon: true
	},
	{
		// 13
		target: '.shared-wallet-menu-item',
		content: (
			<div>
				<h3>Share Your Documents</h3>
				<p>
					This is where institutions or companies can send you document requests, allowing you to pull the
					required documents directly from your personal wallet.{' '}
				</p>
				<h4>Allowing institutions and employers to be confident in the legitimacy of your documents!</h4>
			</div>
		),
		disableBeacon: true
	},
	{
		// 15
		target: '.profile-menu-item',
		content: (
			<div>
				<h3>Your Profile Section</h3>
				<p>Change and or update any personal information here. </p>
			</div>
		),
		disableBeacon: true
	},
	{
		// 15
		target: '.my-account-menu-item',
		content: (
			<div>
				<h3>Track Your Usage</h3>
				<p>Utilize the account section to track your usage and previous order history. </p>
				<h4>Browse products and upgrades here also.</h4>
			</div>
		),
		disableBeacon: true,
		placement: 'bottom'
	},
	{
		// 15
		target: '.faq-menu-item',
		content: (
			<div>
				<h3>Frequently Asked Questions</h3>
				<p>Click here if there are any questions you have!</p>
			</div>
		),
		disableBeacon: true,
		placement: 'bottom'
	},
	{
		// 1
		target: 'body',
		placement: 'center',
		content: (
			<div>
				<h3>Thats Everything!</h3>
				<p>You have completed the self guided tour</p>
				<h4>Time to enjoy using the app!</h4>
			</div>
		),
		disableBeacon: true
	}
];

export const stepsDesktopAndMobilePage2: Step[] = [
	{
		target: '.verifyDocBtn',
		content: (
			<div>
				<h3>Click here to request verification of a document.</h3>
				<p>
					You can request verification for documents you already have, as well as those youve earned but may
					have lost or no longer have access to.
				</p>
			</div>
		),
		disableBeacon: true
	}
];

export const stepsDesktopAndMobilePage3: Step[] = [
	{
		target: '.browse-products-btn-account',
		content: (
			<div>
				<h3>Change Licence or Add Features</h3>
				<p>The opportunity to add more document and verification allowances, among other options.</p>
				<h4>Browse products and upgrades here also. </h4>
			</div>
		),
		disableBeacon: true,
		placement: 'bottom'
	}
];

export const stepsDesktopAndMobilePage4: Step[] = [
	{
		target: '.my-journey-cards',
		content: (
			<div>
				<h3>We are excited to support your next steps!.</h3>
				<p>
					Complete your educational or employability profile so the Pearsana platform can connect you with
					educational institutions and employers suited to you and your future!
				</p>
				<h4>More info = better matches. These profiles take 2 minutes to complete.</h4>
			</div>
		),
		disableBeacon: true
	}
];
